import axios from "./axiosinstance";

const UserApi = {

  AddEmployees: () =>
    axios.get(
      "users/add-employees"
    ),

  add: (payload) =>
    axios.post(
      "users/add",
      payload
    ),

  list: () =>
    axios.get(
      "users/list"
    ),

  salesUsers: () =>
    axios.get(
      "users/sales-users"
    ),

 testerUsers: () =>
  axios.get(
    "/users/tester-users"
  ),

  update: (data) =>
    axios.post(
      "users/update",
      data
    ),

  updateStatus: (payload) =>
    axios.post(
      "users/update-status",
      payload
    ),

  delete: (payload) =>
    axios.post(
      "users/delete",
      payload
    ),

};

export default UserApi;